import { render, staticRenderFns } from "./ProductProfileHindiComponent.vue?vue&type=template&id=2e157b96&"
import script from "./ProductProfileHindiComponent.vue?vue&type=script&lang=js&"
export * from "./ProductProfileHindiComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports